import { PublicProfileTypeEnum } from '@on-arte/core-types';
import React from 'react';

import { BaseViewWithBio } from '@onArte/frontend/components';
import { RouteNameEnum } from '@onArte/shared/enums';

export const ArtistDetailsView: React.FC = (): JSX.Element => { 
  return <BaseViewWithBio type={PublicProfileTypeEnum.Manufacturer} route={RouteNameEnum.ArtistDetails} />;
};
